import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/workspace/src/layouts/docs.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ExternalRedirect = makeShortcode("ExternalRedirect");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ExternalRedirect href="https://docs.starswap.xyz/protocol/V2/guides/smart-contract-integration/building-an-oracle" mdxType="ExternalRedirect" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      